import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { TitleConfig, TypographyConfig } from '@vds-core/typography';
import { colors } from '@vds-core/theme';
var coreTypescale = TypographyConfig.getTypescale();
/*
fontWeightStrong represents the font weight found in 
typography used when the component is bolded. Font weight is
not exported by typography configs due to the fact that 
typography components may have multiple font weight options
*/

var fontWeightStrong = 750;
var fontWeightVDS = 700;
var propTypes = {
  /**
   * @ignore
   */
  label: PropTypes.string.isRequired,

  /**
   * @ignore
   */
  isActive: PropTypes.bool,
  // DEPRECATED

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  accentFill: PropTypes.bool,

  /**
   * @ignore
   */
  indicatorFillTab: PropTypes.bool,

  /**
   * @ignore
   */
  accentPosition: PropTypes.oneOf(['bottom', 'top', 'none']),
  //DEPRECATED

  /**
   * @ignore
   */
  indicatorPosition: PropTypes.oneOf(['bottom', 'top', 'none']),

  /**
   * @ignore
   */
  uniqueId: PropTypes.string,

  /**
   * @ignore
   */
  tabHeight: PropTypes.string,

  /**
   * @ignore
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  minHeight: PropTypes.bool,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object
};
var defaultProps = {
  selected: false,
  accentFill: false,
  indicatorFillTab: false,
  indicatorPosition: 'top',
  uniqueId: undefined,
  tabHeight: '44px',
  focusState: false,
  minHeight: false,
  typescale: coreTypescale,
  titleConfig: TitleConfig,
  colorConfig: colors
};

var buildAccentStyles = function buildAccentStyles(props) {
  var accentFill = props.accentFill,
      indicatorFillTab = props.indicatorFillTab;
  var styles = '';

  if (accentFill || indicatorFillTab) {
    styles += "\n      width: ".concat(calculateRem(80), ";\n      padding-right: 1rem;\n      margin-right: 0;\n    ");
  } else {
    styles += "\n      padding-right: 0;\n    ";
  }

  return styles;
}; //padding: ${calculateRem(16, 0, 16, 0)};


var StyledTabButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledTabButton",
  componentId: "sc-xumbrb-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 0px;\n  border: 0;\n  display: inline-block;\n  margin: 0;\n  text-decoration: none;\n  text-align: left;\n  cursor: pointer;\n  background-color: transparent;\n  appearance: none;\n  border-radius: 0;\n  height: ", ";\n  min-height: ", ";\n  line-height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  color: ", ";\n  overflow: visible;\n\n  &:active,\n  &:visited,\n  &:hover {\n    outline: none;\n  }\n  > * {\n    outline: none;\n  }\n\n  > * {\n    height: 100%;\n    width: 100%;\n  }\n\n  ", ";\n  ", "\n  ", ";\n  border-width: 0 0 4px;\n  ", ";\n"])), function (_ref) {
  var tabHeight = _ref.tabHeight;
  return tabHeight;
}, function (_ref2) {
  var minHeight = _ref2.minHeight;
  return minHeight ? '44px' : '44px';
}, function (_ref3) {
  var titleConfig = _ref3.titleConfig;
  return calculateRem(titleConfig.lineHeight);
}, function (_ref4) {
  var titleConfig = _ref4.titleConfig;
  return calculateRem(titleConfig.fontSize);
}, function (_ref5) {
  var titleConfig = _ref5.titleConfig;
  return titleConfig.fontFamily;
}, function (_ref6) {
  var typescale = _ref6.typescale;
  return typescale === 'VDS' ? fontWeightVDS : fontWeightStrong;
}, function (_ref7) {
  var selected = _ref7.selected,
      colorConfig = _ref7.colorConfig,
      inverted = _ref7.inverted;
  return selected ? inverted ? colorConfig.white : colorConfig.black : colorConfig.coolGray6;
}, function (_ref8) {
  var focusState = _ref8.focusState,
      inverted = _ref8.inverted,
      colorConfig = _ref8.colorConfig;
  return focusState && "\n  &:focus:not(:hover) {\n    outline: none;\n    span {\n      position: relative;\n      display: block;\n      height: auto;\n      width: auto;\n      overflow: visible;\n      &::after {\n        border: ".concat(calculateRem(1), " dashed ").concat(inverted ? colorConfig.white : colorConfig.black, ";\n        content: '';\n        top: ").concat(calculateRem(-2), ";\n        bottom: ").concat(calculateRem(-3), ";\n        left: ").concat(calculateRem(-3), ";\n        width: calc(100% + ").concat(calculateRem(4), ");\n        position: absolute;\n      }\n    }\n  }\n  &::-moz-focus-inner, \n  ::-moz-focus-inner {\n    border: 0;\n  }\n  &:focus:hover {\n    outline:none;\n  }\n  ");
}, function (_ref9) {
  var selected = _ref9.selected,
      position = _ref9.position,
      colorConfig = _ref9.colorConfig;
  return "\n\n    &:hover {\n      &::before {\n        background:  ".concat(selected ? colorConfig.red : colorConfig.coolGray6, ";\n        box-shadow: none;\n        content: '';\n        width: 100%;\n        position: absolute;\n        ").concat(position, ": 0px;\n        height: 4px;\n        z-index: 1;\n      }\n    }\n  ");
}, function (_ref10) {
  var selected = _ref10.selected,
      position = _ref10.position,
      colorConfig = _ref10.colorConfig;
  return "\n    &::before {\n      background:  ".concat(selected ? colorConfig.red : 'none', ";\n      box-shadow: none;\n      content: '';\n      width: 100%;\n      position: absolute;\n      ").concat(position, ": 0px;\n      height: 4px;\n      z-index: 1;\n    }\n  ");
}, function (props) {
  return buildAccentStyles(props);
});
var TabWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "TabWrapper",
  componentId: "sc-xumbrb-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
/**
 * @ignore
 */

var TabButton = function TabButton(_ref11) {
  var accentFill = _ref11.accentFill,
      indicatorFillTab = _ref11.indicatorFillTab,
      indicatorPosition = _ref11.indicatorPosition,
      accentPosition = _ref11.accentPosition,
      isActive = _ref11.isActive,
      selected = _ref11.selected,
      label = _ref11.label,
      uniqueId = _ref11.uniqueId,
      tabHeight = _ref11.tabHeight,
      focusState = _ref11.focusState,
      typescale = _ref11.typescale,
      titleConfig = _ref11.titleConfig,
      colorConfig = _ref11.colorConfig,
      minHeight = _ref11.minHeight,
      analyticsTrack = _ref11.analyticsTrack,
      track = _ref11.track,
      clickStream = _ref11.clickStream,
      dataTrack = _ref11.dataTrack,
      position = _ref11.position,
      cta = _ref11.cta,
      level = _ref11.level,
      inverted = _ref11.inverted,
      ariaLabel = _ref11.ariaLabel;

  function _blurElem(e) {
    if (e.type === 'click' && e.detail !== 0) {
      e.currentTarget.blur();
    }
  }

  var fontsize = typescale === 'VDS' ? 'XSmall' : 'extraSmall';
  var titleExtraSmall = titleConfig.getStyles(typescale, 'desktop', fontsize);
  return /*#__PURE__*/React.createElement(StyledTabButton, {
    id: uniqueId,
    role: "tab",
    "aria-selected": isActive || selected,
    "aria-label": ariaLabel,
    tabIndex: selected ? 0 : -1,
    accentFill: accentFill,
    indicatorFillTab: indicatorFillTab,
    position: accentPosition || indicatorPosition,
    selected: isActive || selected,
    tabHeight: tabHeight,
    onClick: _blurElem,
    focusState: focusState,
    titleConfig: titleExtraSmall,
    typescale: typescale,
    colorConfig: colorConfig,
    minHeight: minHeight,
    inverted: inverted,
    "data-clickstream": clickStream,
    "data-analyticstrack": analyticsTrack,
    "data-track": track,
    "data-sitecat-datatrack": dataTrack,
    "data-sitecat-position": position,
    "data-sitecat-level": level,
    "data-sitecat-cta": cta
  }, /*#__PURE__*/React.createElement(TabWrapper, null, label));
};

TabButton.propTypes = propTypes;
TabButton.defaultProps = defaultProps;
export default TabButton;